import {
  IconNotes,
  IconCalendarStats,
  IconGauge,
  IconPresentationAnalytics,
  IconFileAnalytics,
  IconAdjustments,
  IconLock,
} from "@tabler/icons";
export default function data(role) {
  switch (role) {
    case "admin":
      return [
        { label: "Dashboard", icon: IconGauge, link: "/admin/dashboard" },
        {
          label: "Accounts",
          icon: IconLock,
          link: "#",
          links: [
            { label: "Users", link: "/users" },
            { label: "Staff", link: "/staff" },
            { label: "Clients", link: "/client" },
            { label: "Content Feeders", link: "/feeders" },
            { label: "Content Validators", link: "/validators" },
          ],
        },
        {
          label: "Exams",
          icon: IconNotes,
          link: "#",
          initiallyOpened: false,
          links: [
            { label: "Series", link: "/ts" },
            { label: "Tests", link: "/tests" },
          ],
        },
        {
          label: "Question Bank",
          icon: IconCalendarStats,
          link: "#",
          links: [
            { label: "View All", link: "/home/qb/list" },
            { label: "Add New", link: "/home/qb/add" },
          ],
        },
        {
          label: "Stories",
          icon: IconPresentationAnalytics,
          link: "/stories",
        },
        {
          label: "Static Material",
          icon: IconFileAnalytics,
          link: "/sm/categories",
        },
        { label: "Orders", icon: IconFileAnalytics, link: "/orders" },
        {
          label: "Payments",
          icon: IconFileAnalytics,
          link: "#",
          links: [{ label: "Claim Requests", link: "/pay/claim/req" }],
        },
        { label: "Settings", icon: IconAdjustments, link: "/manage" },
        {
          label: "Security",
          icon: IconLock,
          link: "#",
          links: [
            { label: "Enable 2FA", link: "/" },
            { label: "Change password", link: "/" },
            { label: "Recovery codes", link: "/" },
          ],
        },
      ];
    case "content_feeder":
      return [
        { label: "Dashboard", icon: IconGauge, link: "/dashboard" },
        {
          label: "Question Bank",
          icon: IconNotes,
          link: "#",
          links: [
            { label: "View All", link: "/home/qb/list" },
            { label: "Add New", link: "/home/qb/add" },
          ],
        },
      ];
    case "content_validator":
      return [
        { label: "Dashboard", icon: IconGauge, link: "/cv/dashboard" },
        {
          label: "Questions",
          icon: IconNotes,
          link: "/validate/questions",
        },
      ];
  }
}
